import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import CryptoJS from "crypto-js";
import { jwtDecode } from 'jwt-decode';
import HeartAgeCalc from '../CalculatorCodes/HeartAgeCode'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import restrictions from "../../../JSONS/calculator_res.json"

const HeartAgeCalculator = () => {

    const Navigate = useNavigate();
    const MySwal = withReactContent(Swal)

    const [validation, setvalidation] = useState({
      "Smoke": "empty",
      "Cardio": "empty",
      "Height": "empty",
      "Weight": "empty",
      "Blood": "empty",
      "Choles": "empty"
    });

    const [PMH,setPMH] = useState([])
    const [Smoke,setSmoke] = useState("")
    const [PastSmoke,setPastSmoke] = useState(false)
    //const [Cardio,setCardio] = useState("")
    //const [PastCardio,setPastCardio] = useState(false)
    const [Height,setHeight] = useState("")
    const [PastHeight,setPastHeight] = useState(false)
    const [Weight,setWeight] = useState("")
    const [PastWeight,setPastWeight] = useState(false)
    const [IMC,setIMC] = useState("")
    const [Sistolic,setSistolic] = useState("")
    const [PastSistolic,setPastSistolic] = useState(false)
    const [Choles,setCholes] = useState("")
    const [PastCholes,setPastCholes] = useState(false)

    const [ToLipidic, setToLipidic] = useState(false)
    const [Calculated,setCalculated] = useState("")
    const [OneTime, setOneTime] = useState(0)
    const [PageStart, setPageStart] = useState(true)
    const [TaskDone, setTaskDone] = useState(false)

    const [Risk, setRisk] = useState(0)
    const [WOSmoke,setWOSmoke] = useState(-1)
    const [RegCholes,setRegCholes] = useState(-1)
    const [RegSistolic,setRegSistolic] = useState(-1)

    const Token = sessionStorage.getItem('token') ? sessionStorage.getItem('token') : null;
    const decodedToken = Token ? jwtDecode(CryptoJS.AES.decrypt(Token, process.env.REACT_APP_TOKEN_ENC,{ mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }).toString(CryptoJS.enc.Utf8)) : null;
    const opening = decodedToken && decodedToken.health_report === false && window.localStorage.getItem("HabitsCalculated") ? JSON.parse(window.localStorage.getItem("HabitsCalculated")) : decodedToken ? decodedToken.health_report : false

    const Gender = decodedToken ? parseInt(decodedToken.gender) : null;

    const DoB = decodedToken ? new Date(decodedToken.born) : null;
    const DoBMonth = DoB ? DoB.getMonth() + 1 : 0
    const DoBDay = DoB ? DoB.getDate() : 0

    function AgeCalc() {
        const currentDate = new Date();
    
        const age = currentDate.getFullYear() - DoB.getFullYear();
        const currentMonth = currentDate.getMonth()+1;
        const currentDay = currentDate.getDate();
    
        if (age > 15) {
          if (currentMonth > DoBMonth || (currentMonth === DoBMonth && currentDay >= DoBDay)) {
            return age;
          } else {
            return age-1;
          }
        } else if (age === 15) {
    
          if (currentMonth > DoBMonth || (currentMonth === DoBMonth && currentDay >= DoBDay)) {
            return age;
          }
        }
    
        return false;
    }
    const Age = DoB ? AgeCalc() : 0

    
    useEffect(() => {
      if(!opening || Age < restrictions["cardio_risk"].min_age || Age > restrictions["cardio_risk"].max_age) {
        window.scrollTo(0, 0);
        Navigate("/perfil-de-usuario/calculadora-de-salud")
      }
    }, [opening, Navigate, Age]);

    const handleChange = (value, setValue) => {
      const result = value.replace(/\D/g, '');
      setValue(result.slice(0, 3));
    };

    function HandleSubmit() {
      let isSmokeValid = Smoke !== "NO" && Smoke !== "SÍ" ? "invalid" : "valid";
      //let isCardioValid = Cardio !== "NO" && Cardio !== "SÍ" ? "invalid" : "valid";
      let isWeightValid = Weight.trim() === "" ? "invalid" : "valid";
      let isHeightValid = Height.trim() === "" ? "invalid" : "valid";
      let isCholesValid = Choles.trim() === "" ? "invalid" : Choles >= 550 ? "invalid" : "valid";
      let isBloodValid = Sistolic.trim() === "" ? "invalid" : Sistolic < 40 ? "invalid" : Sistolic > 370 ? "invalid" : "valid";

      if(Weight < 2 || Weight > 650) {
        isWeightValid = "invalid"
      }
      if(Height < 54 || Height > 272) {
        isHeightValid = "invalid"
      }

      setvalidation({
          "Smoke": isSmokeValid,
          "Cardio": "valid",
          "Weight": isWeightValid,
          "Height": isHeightValid,
          "Blood": isBloodValid,
          "Choles": isCholesValid,
      });
      let answers = [isSmokeValid,isHeightValid,isWeightValid,isCholesValid,isBloodValid]
  
      if(!answers.includes("invalid")) {
        if(IMC.length === 0) {
          getIMC()
        }
        getHeartAge()
      }
    }

    const getIMC = useCallback((h= Height,w = Weight) => {
      let imc = w/(h/100)**2
      let cats = ["Bajo", "Saludable", "Sobrepeso", "Obesidad I", "Obesidad II", "Obesidad III"]
      let which = 0
      let ideal = [0,0]
      if(imc < 18.5) {
          which = 0
      } else if(imc < 25 & imc >= 18.5) {
          which = 1
      } else if(imc < 30 & imc >= 25) {
          which = 2
      } else if(imc < 35 & imc >= 30) {
          which = 3
      } else if(imc < 40 & imc >= 35) {
          which = 4
      } else {
          which = 5
      }
      ideal[0] = ((h/100)**2) * 18.5
      ideal[1] = ((h/100)**2) * 25
      setIMC([imc, cats[which], parseInt(ideal[0]), parseInt(ideal[1]), w])
    },[Weight,Height])

    function toggleAdditional(id) {
      let tmp = document.getElementById(id)
      if(tmp.className.includes("InformationCollapsed")) {
          tmp.className = tmp.className.replace(" InformationCollapsed", "");
      } else {
          tmp.className += " InformationCollapsed"
      }
    }

    async function getHeartAge() {
      let gender = Gender === 1 ? "M" : "F"
      let res = await HeartAgeCalc(gender, Age, Smoke, Sistolic, Choles)
      setRisk(res)
      //let res10 = await HeartAgeCalc(gender, Age+10, Smoke, Sistolic, Choles)
      //setRisk10(res10)
      //console.log(res)

      if(Smoke === "SÍ") {
          let tmp = await HeartAgeCalc(gender, Age, "NO", Sistolic, Choles)
          setWOSmoke(tmp.heartAge)
      } else setWOSmoke(-1)
  
      if(Sistolic > 120) {
          let tmp = await HeartAgeCalc(gender, Age, Smoke, 120, Choles)
          setRegSistolic(tmp.heartAge)
      } else setRegSistolic(-1)
      
      if(Choles > 154) {
          let tmp = await HeartAgeCalc(gender, Age, Smoke, Sistolic, 154)
          setRegCholes(tmp.heartAge)
      } else setRegCholes(-1)

      getIMC()
      //setCalculated(true)
      uploadHeartAge(res)
    }

    function toggleDescription(type,num="") {
      let tmp = document.getElementById("More"+num)
      let tmp2 = document.getElementById("Less"+num)
      if(type === "Less") {
          tmp.className += " HeartAgeCalculatorResultsRightSideWhatIfConsequenceHidden"
          tmp2.className = tmp2.className.replace(" HeartAgeCalculatorResultsRightSideWhatIfConsequenceHidden", "");
      } else {
          tmp.className = tmp.className.replace(" HeartAgeCalculatorResultsRightSideWhatIfConsequenceHidden", "");
          tmp2.className += " HeartAgeCalculatorResultsRightSideWhatIfConsequenceHidden"
      }
    }

    const requestGetPatient = useCallback(async() => {

      MySwal.fire({
        position: "center",
        html: 
        <div className="FullAlertWidth1">
          <div className="FullAlertUpTitle">Cargando información de perfil...</div>
          <img alt="" className="FullAlertImageGif" src="https://static.yomecontrolo.cl/public/icons/ymc-loading.gif"/>
        </div>,
        color: "#340066",
        customClass: 'swal-wide',
        showConfirmButton: false,
        width: "100%",
      })

      let parameters = {
        rut: decodedToken.rut
      }
  
      let requestOptions = {
        method: 'POST',
        redirect: 'follow',
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(parameters)
      };

      let parameters2 = {
        rut: decodedToken.rut,
        within: [51,52,53,2]
      }
  
      let requestOptions2 = {
        method: 'POST',
        redirect: 'follow',
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(parameters2)
      };

      let tmp = validation
  
      try{
        let resp = await fetch("https://ymc-doc-api.azurewebsites.net/getprofiledata", requestOptions)
        if (resp.status !== 200){
            MySwal.fire({
                icon: "error",
                title: "Ocurrió un error obteniendo los datos",
                text: "Por favor inténtelo más tarde",
                showConfirmButton: true
            });
            return false;
        }
        let data = await resp.json();
        
        if(data.pmh) { 
          setPMH(data.pmh)
          if(data.pmh.includes("AP010")) {
            setSmoke("SÍ")
            setPastSmoke(true)
            tmp["Smoke"] = "valid"
          }
          if(data.pmh.includes("AP035")) {
            Navigate("/perfil-de-usuario/calculadora-de-salud")
          }
        }

        let hasParams = true
        let resp2 = await fetch("https://ymc-graph-api.azurewebsites.net/getuserparams", requestOptions2)
        if (resp2.status !== 200){
            if(resp2.status !== 500) {
            MySwal.fire({
                icon: "error",
                title: "Ocurrió un error al subir los datos",
                text: "Por favor inténtelo más tarde",
                showConfirmButton: true
            });
            return false;
            } else {
            hasParams = false
            }
        }
        let data2 = await resp2.json();
        
        if(hasParams) {
            if(data2.params["51"]) {
              setWeight(data2.params["51"][1])
              setPastWeight(true)
              tmp["Weight"] = "valid"
            }
            if(data2.params["52"]) {
              setHeight(data2.params["52"][1])
              setPastHeight(true)
              tmp["Height"] = "valid"
            }
            if(data2.params["51"] && data2.params["52"]) {
              getIMC(data2.params["52"][1],data2.params["51"][1])
            }
            if(data2.params["53"]) {
              setSistolic(data2.params["53"][1])
              setPastSistolic(true)
              tmp["Blood"] = "valid"
            }
            if(data2.params["2"]) {
              setCholes(data2.params["2"][1])
              setPastCholes(true)
              tmp["Choles"] = "valid"
            }
        }
        setvalidation(tmp)

        MySwal.close();
        setTaskDone(true);
      }
      catch(error){
          MySwal.fire({
            icon: "error",
            title: "Ocurrió un error al subir los datos",
            text: "Por favor inténtelo más tarde",
            showConfirmButton: true
          });
          return false;
      }
    },[MySwal,decodedToken,getIMC,validation,Navigate]);

    const uploadHeartAge = async(res) => {
      
      MySwal.fire({
        position: "center",
        html: 
        <div className="FullAlertWidth1">
          <div className="FullAlertUpTitle">Calculando...</div>
          <img alt="" className="FullAlertImageGif" src="https://static.yomecontrolo.cl/public/icons/ymc-loading.gif"/>
        </div>,
        color: "#340066",
        customClass: 'swal-wide',
        showConfirmButton: false,
        width: "100%",
      })
  
      var params = {
          rut: decodedToken.rut,
          gender: Gender,
          age: Age,
          smoke: Smoke,
          cardio: "NO",
          systolic: Sistolic,
          choles: Choles,
          height: Height,
          weight: Weight,
          heart_age: res["heartAge"],
          cardio_risk: res["cardioRisk"],
      };

      let finalParamids = [
        !PastWeight ? 51 : false,
        !PastHeight ? 52 : false,
        !PastSistolic ? 53 : false,
        !PastCholes ? 2 : false,
      ].filter(med => med !== false);
      let finalResults = [
        !PastWeight ? Weight : false,
        !PastHeight ? Height : false,
        !PastSistolic ? Sistolic : false,
        !PastCholes ? Choles : false,
      ].filter(med => med !== false);

      let Dated = new Date()
  
      let params2 = {
        rut: decodedToken.rut,
        sex: Gender === 1 ? "M" : "F",
        ans: finalResults,
        ids: finalParamids,
        cardioRisk: res["cardioRisk"],
        heartAgeDif: Age >= 40 ? res["heartAge"] - Age : false,
        date: Dated
      }

      if(!PMH.includes("AP010") && Smoke === "SÍ") {
        let newpmh = PMH.push("AP010")
        params2['pmh'] = newpmh
      } else if(PMH.includes("AP010") && Smoke === "NO") {
        let newpmh = PMH.filter(med => med !== "AP010")
        params2['pmh'] = newpmh
      }
    
      let requestOptions = {
        method: 'POST',
        redirect: 'follow',
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(params)
      };

      let requestOptions2 = {
        method: 'POST',
        redirect: 'follow',
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(params2)
      };
  
      try{
        
        const resp = await fetch("https://ymc-doc-api.azurewebsites.net/userheartage", requestOptions)
        if (resp.status !== 200){
          MySwal.fire({
            icon: "error",
            title: "Ocurrió un error al subir los datos",
            text: "Por favor inténtelo más tarde",
            showConfirmButton: true
          });
          return false;
        }

        const resp2 = await fetch("https://ymc-graph-api.azurewebsites.net/addnewparamresults", requestOptions2)
        if (resp2.status !== 200){
          MySwal.fire({
            icon: "error",
            title: "Ocurrió un error al subir los datos",
            text: "Por favor inténtelo más tarde",
            showConfirmButton: true
          });
          return false;
        }
    
        setTaskDone(true)
        setCalculated(true)
        setOneTime(true)
        MySwal.close();
      }
      catch(error){
        //console.log("there has been an error login in")
        MySwal.fire({
          icon: "error",
          title: "Ocurrió un error al subir los datos",
          text: "Por favor inténtelo más tarde",
          showConfirmButton: true
        });
        return false
      }
  }

    useEffect(() => {
      if(ToLipidic) {
        window.scrollTo(0, 0);
        Navigate("/packs-de-examenes/detalles-de-pack?pack=PM00YMC041")
      }
      
      if(OneTime) {
        document.body.scrollTop = 0
        document.documentElement.scrollTop = 0
        setOneTime(false)
      }

      if(PageStart) {
        requestGetPatient()
        setPageStart(false)
      }
    },[ToLipidic, OneTime, PageStart, Navigate, requestGetPatient])

    function toggleAdditional2(id) {
      let tmp = document.getElementById(id)
      if(tmp.className.includes("UserWelcomeBlockPage1SpecificsHidden")) {
        tmp.className = tmp.className.replace(" UserWelcomeBlockPage1SpecificsHidden", "");
      } else {
        tmp.className += " UserWelcomeBlockPage1SpecificsHidden"
      }
    }

    return (
        <div className='UserProfileFull'>
            <div className='UserProfileInnerDiv'>
                <div className='UserProfileInnerDivCalculatorWhiteBlock2'>
                  {!Calculated && TaskDone ?
                  <>
                  <div className='UserWelcomeBlockPageWideFlex'>
                    <div className='UserWelcomeBlockPageWideSideL'>
                      <div className='UserWelcomeBlockPage1TitleFlex'>
                          <div className='UserWelcomeBlockPage1Title'>Calcula tu riesgo cardiovascular&ensp;</div>
                          <div className="UserWelcomeBlockPage1MoreInfo" onClick={() => toggleAdditional2("Added1")}>?</div>
                      </div>
                      <div className="UserWelcomeBlockPage1Specifics UserWelcomeBlockPage1SpecificsHidden" id="Added1">Este instrumento está indicado para personas con edades comprendidas entre 30 y 65 años, especialmente aquellas que puedan tener uno o varios factores de riesgo cardiovascular y no estén diagnosticados previamente de ninguna enfermedad cardiovascular, diabetes tipo II o diabetes tipo I con microalbuminuria.</div>
                      <img alt="" className='UserWelcomeBlockPage1TitleFoodImage' src="https://static.yomecontrolo.cl/public/img/calculator/BigHeartLowRiskTp.png" />
                    </div>
                    <div className='UserWelcomeBlockPageWideSideR'>
                    <div className="UserProfileHeartAgeCalculatorWhiteBlockTitle">Completa y/o modifica los siguientes datos:</div>
                    <div className="UserWelcomeBlockYNQuestion">Mi historial médico</div>
                    <div className="UserProfileHeartAgeCalculatorWhiteBlockPrecompleted">
                      • Edad: {Age}<br/>
                      • Sexo al Nacer: {Gender === 1 ? "Hombre" : "Mujer"}<br/>
                      {PastSmoke ?
                      <div className="UserProfileHeartAgeCalculatorWhiteBlockPrecompletedFlex">
                        <div className="UserProfileHeartAgeCalculatorWhiteBlockPrecompletedFlexLeft">• Fumador: {Smoke}</div>
                        <div className="UserProfileHeartAgeCalculatorWhiteBlockPrecompletedFlexRight" onClick={() => setPastSmoke(false)}>Editar
                          <img alt="" className='UserProfileInnerDivCalculatorWhiteBlockRightButtonPlusIcon' src="https://static.yomecontrolo.cl/public/icons/PurpleWritingIcon.svg" />
                        </div>
                      </div>
                      : null}
                      {/*PastCardio ?
                      <div className="UserProfileHeartAgeCalculatorWhiteBlockPrecompletedFlex">
                        <div className="UserProfileHeartAgeCalculatorWhiteBlockPrecompletedFlexLeft">• Enfermedad Cardiovascular: {Cardio}</div>
                        <div className="UserProfileHeartAgeCalculatorWhiteBlockPrecompletedFlexRight" onClick={() => setPastCardio(false)}>Editar
                          <img alt="" className='UserProfileInnerDivCalculatorWhiteBlockRightButtonPlusIcon' src="https://static.yomecontrolo.cl/public/icons/PurpleWritingIcon.svg" />
                        </div>
                      </div>
                      : null*/}
                      {PastHeight ?
                      <div className="UserProfileHeartAgeCalculatorWhiteBlockPrecompletedFlex">
                        <div className="UserProfileHeartAgeCalculatorWhiteBlockPrecompletedFlexLeft">• Estatura: {Height} cm</div>
                        <div className="UserProfileHeartAgeCalculatorWhiteBlockPrecompletedFlexRight" onClick={() => setPastHeight(false)}>Editar
                          <img alt="" className='UserProfileInnerDivCalculatorWhiteBlockRightButtonPlusIcon' src="https://static.yomecontrolo.cl/public/icons/PurpleWritingIcon.svg" />
                        </div>
                      </div>
                      : null}
                      {PastWeight ? 
                      <div className="UserProfileHeartAgeCalculatorWhiteBlockPrecompletedFlex">
                        <div className="UserProfileHeartAgeCalculatorWhiteBlockPrecompletedFlexLeft">• Peso: {Weight} Kg</div>
                        <div className="UserProfileHeartAgeCalculatorWhiteBlockPrecompletedFlexRight" onClick={() => setPastWeight(false)}>Editar
                          <img alt="" className='UserProfileInnerDivCalculatorWhiteBlockRightButtonPlusIcon' src="https://static.yomecontrolo.cl/public/icons/PurpleWritingIcon.svg" />
                        </div>
                      </div>
                      : null}
                      {PastSistolic ? 
                      <div className="UserProfileHeartAgeCalculatorWhiteBlockPrecompletedFlex">
                        <div className="UserProfileHeartAgeCalculatorWhiteBlockPrecompletedFlexLeft">• Presión Sistólica: {Sistolic} mmHg</div>
                        <div className="UserProfileHeartAgeCalculatorWhiteBlockPrecompletedFlexRight" onClick={() => setPastSistolic(false)}>Editar
                          <img alt="" className='UserProfileInnerDivCalculatorWhiteBlockRightButtonPlusIcon' src="https://static.yomecontrolo.cl/public/icons/PurpleWritingIcon.svg" />
                        </div>
                      </div>
                      : null}
                      {PastCholes ? 
                      <div className="UserProfileHeartAgeCalculatorWhiteBlockPrecompletedFlex">
                        <div className="UserProfileHeartAgeCalculatorWhiteBlockPrecompletedFlexLeft">• Colesterol Total: {Choles} mg/dL</div>
                        <div className="UserProfileHeartAgeCalculatorWhiteBlockPrecompletedFlexRight" onClick={() => setPastCholes(false)}>Editar
                          <img alt="" className='UserProfileInnerDivCalculatorWhiteBlockRightButtonPlusIcon' src="https://static.yomecontrolo.cl/public/icons/PurpleWritingIcon.svg" />
                        </div>
                      </div>
                      : null}
                    </div>
                    <div className="UserProfileHeartAgeCalculatorWhiteBlockQuestionFlex">
                        {PastSmoke ?
                        null
                        :
                        <div className="UserProfileHeartAgeCalculatorWhiteBlockQuestion">
                          <div className="UserWelcomeBlockYNQuestion UserWelcomeBlockYNQuestionFullSize" style={{color: validation["Smoke"] === "invalid" ? "red" : validation["Smoke"] === "valid" ? "#8BC53F" : null}}>Indícanos si fumas</div>
                          <div className="DiabetesRiskCalculatorRightSideSurveyQ1TileFlex">
                            <div className={Smoke === "NO" ? "DiabetesRiskCalculatorRightSideSurveyQ1Tile DiabetesRiskCalculatorRightSideSurveyQ1ActiveTile" : "DiabetesRiskCalculatorRightSideSurveyQ1Tile"} style={{borderBottom: validation["Smoke"] === "invalid" ? "red solid 1px" : validation["Smoke"] === "valid" ? "#8BC53F solid 1px" : "#BFD4E4 solid 1px", backgroundColor: Smoke === "NO" ? "#F2F2FF" : Smoke === "SÍ" || validation["Smoke"] === "valid" || validation["Smoke"] === "empty" ? "white" : "#FFFAEA"}} id="NoSmokeTile" onClick={() => setSmoke("NO")}>
                              <div className="DiabetesRiskCalculatorRightSideSurveyQ1TileTitleText">NO</div>
                            </div>
                            <div className={Smoke === "SÍ" ? "DiabetesRiskCalculatorRightSideSurveyQ1Tile DiabetesRiskCalculatorRightSideSurveyQ1ActiveTile" : "DiabetesRiskCalculatorRightSideSurveyQ1Tile"} style={{borderBottom: validation["Smoke"] === "invalid" ? "red solid 1px" : validation["Smoke"] === "valid" ? "#8BC53F solid 1px" : "#BFD4E4 solid 1px", backgroundColor: Smoke === "SÍ" ? "#F2F2FF" : Smoke === "NO" || validation["Smoke"] === "valid" || validation["Smoke"] === "empty" ? "white" : "#FFFAEA"}} id="SmokeTile" onClick={() => setSmoke("SÍ")}>
                              <div className="DiabetesRiskCalculatorRightSideSurveyQ1TileTitleText">SÍ</div>
                            </div>
                          </div>
                          {validation["Smoke"] === "invalid" ?
                              <div className='BloodAlert' style={{ color: "red", fontWeight: "500" }}> Indique si fuma o no </div>
                          : null }
                        </div>
  }
                        {/*PastCardio ?
                        null
                        :
                        <div className="UserProfileHeartAgeCalculatorWhiteBlockQuestion">
                          <div className="UserWelcomeBlockYNQuestion UserWelcomeBlockYNQuestionFullSize" style={{color: validation["Cardio"] === "invalid" ? "red" : validation["Cardio"] === "valid" ? "#8BC53F" : null}}>¿Ha sido diagnosticado con alguna enfermedad cardiovascular?</div>
                          <div className="DiabetesRiskCalculatorRightSideSurveyQ1TileFlex">
                            <div className={Cardio === "NO" ? "DiabetesRiskCalculatorRightSideSurveyQ1Tile DiabetesRiskCalculatorRightSideSurveyQ1ActiveTile" : "DiabetesRiskCalculatorRightSideSurveyQ1Tile"} style={{borderBottom: validation["Cardio"] === "invalid" ? "red solid 1px"  : validation["Cardio"] === "valid" ? "#8BC53F solid 1px": "#BFD4E4 solid 1px", backgroundColor: Cardio === "NO" ? "#F2F2FF" : Cardio === "SÍ" || validation["Cardio"] === "valid" || validation["Cardio"] === "empty" ? "white" : "#FFFAEA"}} id="NoCardioTile" onClick={() => setCardio("NO")}>
                              <div className="DiabetesRiskCalculatorRightSideSurveyQ1TileTitleText">NO</div>
                            </div>
                            <div className={Cardio === "SÍ" ? "DiabetesRiskCalculatorRightSideSurveyQ1Tile DiabetesRiskCalculatorRightSideSurveyQ1ActiveTile" : "DiabetesRiskCalculatorRightSideSurveyQ1Tile"} style={{borderBottom: validation["Cardio"] === "invalid" ? "red solid 1px" : validation["Cardio"] === "valid" ? "#8BC53F solid 1px" : "#BFD4E4 solid 1px", backgroundColor: Cardio === "SÍ" ? "#F2F2FF" : Cardio === "NO" || validation["Cardio"] === "valid" || validation["Cardio"] === "empty" ? "white" : "#FFFAEA"}} id="CardioTile" onClick={() => setCardio("SÍ")}>
                              <div className="DiabetesRiskCalculatorRightSideSurveyQ1TileTitleText">SÍ</div>
                            </div>
                          </div>
                          {validation["Cardio"] === "invalid" ?
                              <div className='BloodAlert' style={{ color: "red", fontWeight: "500" }}>Indique si le han dado este diagnóstico</div>
                          : null }
                        </div>
  */}
                      {PastHeight ?
                      null
                      :
                      <div className="UserProfileHeartAgeCalculatorWhiteBlockQuestion3">
                        <div className="HeartAgeCalculatorRightSideSurveyQ1Flex">
                            <div className="UserWelcomeBlockYNQuestion UserWelcomeBlockYNQuestionFullSize" style={{color: validation["Height"] === "invalid" ? "red" : validation["Height"] === "valid" ? "#8BC53F" : null}}>Indícanos tu estatura</div>
                        </div>
                        <div className="HeartAgeCalculatorRightSideSurveyQ1MeasureFlex">
                            <input
                                value={Height}
                                className="SignInInnerBoxInputTile"
                                style={{ borderBottom: validation["Height"] === "invalid" ? "red solid 1px" : validation["Height"] === "valid" ? "#8BC53F solid 1px" : Height.length !== 0 ? "#330066 solid 1px" : "#BFD4E4 solid 1px", backgroundColor: validation["Height"] === "invalid" ? "#FFFAEA" : validation["Height"] === "valid" || Height.length === 0 ? "#FBFFFF" : "#F2F2FF" }}
                                id="YMCHeight"
                                onChange={(e) => handleChange(e.target.value,setHeight)}
                                placeholder="Ingresa tu altura" />
                            <div className="HeartAgeCalculatorRightSideSurveyQ4InputMeasure">cm</div>
                        </div>
                        {validation["Height"] === "invalid" ?
                            <div className='BloodAlert' style={{ color: "red", fontWeight: "500" }}> Input inválido o fuera de rango </div>
                        : null }
                      </div>
  }
                      {PastWeight ?
                      null
                      :
                      <div className="UserProfileHeartAgeCalculatorWhiteBlockQuestion3">
                        <div className="HeartAgeCalculatorRightSideSurveyQ1Flex">
                            <div className="UserWelcomeBlockYNQuestion UserWelcomeBlockYNQuestionFullSize" style={{color: validation["Weight"] === "invalid" ? "red" : validation["Weight"] === "valid" ? "#8BC53F" : null}}>Indícanos tu peso</div>
                        </div>
                        <div className="HeartAgeCalculatorRightSideSurveyQ1MeasureFlex">
                            <input
                                value={Weight}
                                className="SignInInnerBoxInputTile"
                                style={{ borderBottom: validation["Weight"] === "invalid" ? "red solid 1px" : validation["Weight"] === "valid" ? "#8BC53F solid 1px" : Weight.length !== 0 ? "#330066 solid 1px" : "#BFD4E4 solid 1px", backgroundColor: validation["Weight"] === "invalid" ? "#FFFAEA" : validation["Weight"] === "valid" || Weight.length === 0 ? "#FBFFFF" : "#F2F2FF" }}
                                id="YMCWeight"
                                onChange={(e) => handleChange(e.target.value,setWeight)}
                                placeholder="Ingresa tu peso" />
                            <div className="HeartAgeCalculatorRightSideSurveyQ4InputMeasure">Kg</div>
                        </div>
                        {validation["Weight"] === "invalid" ?
                            <div className='BloodAlert' style={{ color: "red", fontWeight: "500" }}> Input inválido o fuera de rango </div>
                        : null }
                      </div>
  }
                      {PastSistolic ?
                      null
                      :
                      <div className="UserProfileHeartAgeCalculatorWhiteBlockQuestion3">
                        <div className="HeartAgeCalculatorRightSideSurveyQ1Flex">
                            <div className="UserWelcomeBlockYNQuestion UserWelcomeBlockYNQuestionFullSize" style={{color: validation["Blood"] === "invalid" ? "red" : validation["Blood"] === "valid" ? "#8BC53F" : null}}>Indícanos tu presión arterial sistólica&ensp;</div>
                            <div className="UserWelcomeBlockPage1MoreInfo" onClick={() => toggleAdditional("PressureInfo")}>?</div>
                        </div>
                        <div className="HeartAgeCalculatorRightSideSurveyQ1SuggestionText InformationCollapsed" id="PressureInfo">Es la cifra superior (y más alta) en una medición de la presión arterial.</div>
                        <div className="HeartAgeCalculatorRightSideSurveyQ1MeasureFlex">
                            <input
                                value={Sistolic}
                                className="SignInInnerBoxInputTile"
                                style={{ borderBottom: validation["Blood"] === "invalid" ? "red solid 1px" : validation["Blood"] === "valid" ? "#8BC53F solid 1px" : Sistolic.length !== 0 ? "#330066 solid 1px" : "#BFD4E4 solid 1px", backgroundColor: validation["Blood"] === "invalid" ? "#FFFAEA" : validation["Blood"] === "valid" || Sistolic.length === 0 ? "#FBFFFF" : "#F2F2FF" }}
                                id="YMCSistolic"
                                onChange={(e) => handleChange(e.target.value,setSistolic)}
                                placeholder="Ingresa tu presión sistólica" />
                            <div className="HeartAgeCalculatorRightSideSurveyQ4InputMeasure">mmHg</div>
                        </div>
                        {validation["Blood"] === "invalid" ?
                            <div className='BloodAlert' style={{ color: "red", fontWeight: "500" }}> Input inválido o fuera de rango </div>
                        : null }
                      </div>
  }
                      {PastCholes ?
                      null
                      :
                      <div className="UserProfileHeartAgeCalculatorWhiteBlockQuestion3">
                        <div className="HeartAgeCalculatorRightSideSurveyQ1Flex">
                            <div className="UserWelcomeBlockYNQuestion UserWelcomeBlockYNQuestionFullSize" style={{color: validation["Choles"] === "invalid" ? "red" : validation["Choles"] === "valid" ? "#8BC53F" : null}}>Indícanos tu colesterol total (venoso)&ensp;</div>
                            <div className="UserWelcomeBlockPage1MoreInfo" onClick={() => toggleAdditional("CholesterolSuggestion")}>?</div>
                        </div>
                        <div className="HeartAgeCalculatorRightSideSurveyQ1SuggestionText InformationCollapsed" id="CholesterolSuggestion">¿No sabes tu Colesterol Total? Te damos una <span className='HeartAgeCalculatorRightSideSurveyQ1SuggestionLink' onClick={() => {setToLipidic(true); localStorage.setItem("VisualizePack",JSON.stringify("PM00YMC041"));}}>orden médica gratuita</span> con los exámenes necesarios, para que te pongas al día con tu corazón.</div>
                        <div className="HeartAgeCalculatorRightSideSurveyQ1MeasureFlex">
                            <input
                                value={Choles}
                                className="SignInInnerBoxInputTile"
                                style={{ borderBottom: validation["Choles"] === "invalid" ? "red solid 1px" : validation["Choles"] === "valid" ? "#8BC53F solid 1px" : Choles.length !== 0 ? "#330066 solid 1px" : "#BFD4E4 solid 1px", backgroundColor: validation["Choles"] === "invalid" ? "#FFFAEA" : validation["Choles"] === "valid" || Choles.length === 0 ? "#FBFFFF" : "#F2F2FF" }}
                                id="YMCCholes"
                                onChange={(e) => handleChange(e.target.value,setCholes)}
                                placeholder="Ingresa tu colesterol total" />
                            <div className="HeartAgeCalculatorRightSideSurveyQ4InputMeasure">mg/dL</div>
                        </div>
                        {validation["Choles"] === "invalid" ?
                            <div className='CholesAlert' style={{ color: "red", fontWeight: "500" }}> Input inválido o fuera de rango </div>
                        : null }
                      </div>
  }

                      </div> 
                    </div>
                  </div>
                  <div className='GeneralPurpleButtonFlex UserWelcomeBlockPageButton' onClick={() => HandleSubmit()} >Calcular<div className='triangle'><i className='innerarrowWhite'></i></div></div>
                  </>
                  : Calculated ?
                  <>
                  <div className="HeartAgeCalculatorResultsTitleDiv UserProfileHeartAgeCalculatorWhiteBlockTitleDiv" style={{backgroundColor:"#CCCCFF"}}>
                    <div className="HeartAgeCalculatorRightSideTitleFlex">
                        <img alt="" className="HeartAgeCalculatorRightSideTitleIcon" src="https://static.yomecontrolo.cl/public/icons/HealthCalculatorPurpleLogo.png"/>
                        <div className="HeartAgeCalculatorRightSideTitleInnerDiv">
                            <div className="HeartAgeCalculatorRightSideUpTitle">Calculadora de Salud</div>
                            <div className="HeartAgeCalculatorRightSideTitle">Resultados</div>
                            <div className="HeartAgeCalculatorRightSideUpTitle">Edad del Corazón</div>
                        </div>
                    </div>
                    <img alt="" className="HeartAgeCalculatorResultsTitleYMCLogo" src="https://static.yomecontrolo.cl/public/icons/YMC_Logo_NoText.png"/>
                  </div>
                  <div className='UserWelcomeBlockPageWideFlex'>
                    <div className='UserWelcomeBlockPageWideSideL'>
                      <div className="UserProfileDiabetesWhiteBoxPart2">
                            <h5 className="HeartAgeCalculatorLeftSideResultPartName">1. Análisis de tu Riesgo Cardiovascular</h5>
                            <h2 className="HeartAgeCalculatorLeftSideResultTitle">La edad de tu corazón nos dice sobre tu riesgo cardiovascular en los próximos 10 años</h2>
                            <div className="HeartAgeCalculatorLeftSideResultHeartBlockInnerBlockSmallScreen" style={{ backgroundColor: Risk.cardioRisk === 0 ? "rgba(139, 197, 63, 1)" : Risk.cardioRisk <= 3 ? "rgba(255, 205, 41, 1)" : "rgba(255, 79, 83, 1)", color: Risk.cardioRisk >= 4 ? "white": ""}}>
                                <div className="HeartAgeCalculatorLeftSideResultHeartBlockInnerBlockText1">Tienes un corazón de</div>
                                <div className="HeartAgeCalculatorLeftSideResultHeartBlockInnerBlockText2">{Risk.heartAge} años</div>
                                <div className="HeartAgeCalculatorLeftSideResultHeartBlockInnerBlockText1">Edad Real: {Age}</div>
                                <div className="HeartAgeCalculatorLeftSideResultHeartBlockInnerBlockText3">Riesgo {Risk.cardioRiskCat}</div>
                            </div>
                            <div className="HeartAgeCalculatorLeftSideResultHeartBlock" style={{ maxWidth: "500px", width: "100%", backgroundColor: Risk.cardioRisk === 0 ? "rgba(139, 197, 63, .5)" : Risk.cardioRisk <= 3 ? "rgba(255, 205, 41, .5)" : "rgba(255, 79, 83, .5)", color: Risk.cardioRisk >= 4 ? "white": ""}}>
                                <img alt="" className="HeartAgeCalculatorLeftSideResultHeartImage" src={Risk.cardioRisk === 0 ? "https://static.yomecontrolo.cl/public/img/calculator/BigHeartLowRiskTp.png" : Risk.cardioRisk <= 3 ? "https://static.yomecontrolo.cl/public/img/calculator/BigHeartMidRiskTp.png" : "https://static.yomecontrolo.cl/public/img/calculator/BigHeartHighRiskTp.png"}/>
                                {Age < 40 ?
                                <div className="HeartAgeCalculatorLeftSideResultHeartBlockInnerBlock" style={{ maxWidth: "230px", marginInlineStart:"auto", top:"30px", right: "25px", position:"relative", zIndex:"20", backgroundColor: Risk.cardioRisk === 0 ? "rgba(139, 197, 63, 1)" : Risk.cardioRisk <= 3 ? "rgba(255, 205, 41, 1)" : "rgba(255, 79, 83, 1)", color: Risk.cardioRisk >= 4 ? "white": ""}}>
                                    <div className="HeartAgeCalculatorLeftSideResultHeartBlockInnerBlockText1">Riesgo<br/>Cardiovascular</div>
                                    <div className="HeartAgeCalculatorLeftSideResultHeartBlockInnerBlockText3">{Risk.cardioRiskCat}</div>
                                </div>
                                :
                                <div className="HeartAgeCalculatorLeftSideResultHeartBlockInnerBlock" style={{ maxWidth: "230px", marginInlineStart:"auto", top:"30px", right: "25px", position:"relative", zIndex:"20", backgroundColor: Risk.cardioRisk === 0 ? "rgba(139, 197, 63, 1)" : Risk.cardioRisk <= 3 ? "rgba(255, 205, 41, 1)" : "rgba(255, 79, 83, 1)", color: Risk.cardioRisk >= 4 ? "white": ""}}>
                                    <div className="HeartAgeCalculatorLeftSideResultHeartBlockInnerBlockText1">Tienes un corazón de</div>
                                    <div className="HeartAgeCalculatorLeftSideResultHeartBlockInnerBlockText2">{Risk.heartAge} años</div>
                                    <div className="HeartAgeCalculatorLeftSideResultHeartBlockInnerBlockText1">Edad Real: {Age}</div>
                                    <div className="HeartAgeCalculatorLeftSideResultHeartBlockInnerBlockText3">Riesgo {Risk.cardioRiskCat}</div>
                                </div>
    }
                                <div className="HeartAgeCalculatorLeftSideResultHeartBlockMeterBlock" style={{maxWidth:"375px", width:"100%", left:"0", right:"0", marginInline:"auto"}}>
                                    <div className="HeartAgeCalculatorLeftSideResultHeartBlockMeter" style={{backgroundImage:"url('https://static.yomecontrolo.cl/public/img/calculator/RiskMeterHorizontalSimplified.png')",backgroundPosition: 'left',backgroundSize: 'contain',backgroundRepeat: 'no-repeat'}}>
                                        <img alt="" className="HeartAgeCalculatorLeftSideResultHeartBlockMeterFace" src={Risk.cardioRisk === 0 ? "https://static.yomecontrolo.cl/public/img/calculator/RiskMeter_LowRiskFace.png" : Risk.cardioRisk <= 3 ? "https://static.yomecontrolo.cl/public/img/calculator/RiskMeter_MidRiskFace.png" : "https://static.yomecontrolo.cl/public/img/calculator/RiskMeter_HighRiskFace.png"} style={ Risk.cardioRisk === 0 ? { left: "-5px"} : Risk.cardioRisk <= 3 ? { left: "-3px", right: "0", margin: "0 auto" } : { right: "-5px"} } />
                                    </div>
                                </div>
                            </div>
                            {Age < 40 ?
                            <div className="HeartAgeCalculatorLeftSideResultsListed">Tus resultados:<br/>Riesgo: {Risk.cardioRiskCat} {Risk.cardioRisk*20}%</div>
                            :
                            <>
                            <div className="HeartAgeCalculatorLeftSideResultsListed">Tus resultados:<br/>Edad: {Age} / <br className='HeartAgeCalculatorLeftSideResultsLineBreak'/>Edad Corazón: {Risk.heartAge} / <br className='HeartAgeCalculatorLeftSideResultsLineBreak'/> Riesgo: {Risk.cardioRiskCat} {Risk.cardioRisk*20}%</div>
                            <div className="HeartAgeCalculatorLeftSideResultSubtext">Esto nos dice que tu corazón tiene la edad de una persona sana de {Risk.heartAge}, lo que se traduce a las mismas posibilidades de sufrir un evento cardiovascular que una persona de esta edad ({Risk.heartAge}). Si consideras que tu edad real es de {Age}, estas aumentando tu riesgo en {Risk.heartAge-Age} años.</div>
                            </>
    }
                        </div>

                        <div className="UserProfileDiabetesWhiteBoxPart2">
                            <div className="HeartAgeCalculatorLeftSideResultSubtext" id="More1">Este riesgo fue calculado utilizando la metodología SCORE, la cual es una herramienta de evaluación de riesgos fácil de usar, desarrollada para ayudar a los profesionales de la salud a evaluar el riesgo de que su paciente muera por causas cardiovasculares...<br/><br/><span className='HeartAgeCalculatorResultsRightSideWhatIfConsequenceTextOption' onClick={() => toggleDescription("Less",1)} style={{fontWeight: "800"}}>Leer más...</span></div>
                            <div className="HeartAgeCalculatorLeftSideResultSubtext HeartAgeCalculatorResultsRightSideWhatIfConsequenceHidden" id="Less1">Este riesgo fue calculado utilizando la metodología SCORE, la cual es una herramienta de evaluación de riesgos fácil de usar, desarrollada para ayudar a los profesionales de la salud a evaluar el riesgo de que su paciente muera por causas cardiovasculares (cardíacas y circulatorias), como infarto de miocardio (ataque cardíaco), insuficiencia cardíaca (incapacidad del corazón para bombear sangre) o accidente cerebrovascular (bloqueo repentino de un vaso sanguíneo que transporta oxígeno y nutrientes) a lo largo de un período de diez años. Incluye múltiples factores de riesgo, la mayoría de los cuales se pueden abordar, como la presión arterial, el colesterol en sangre (nivel de grasas en la sangre) y el hábito de fumar. También incluye factores de riesgo no modificables como la edad y el sexo. SCORE le muestra cómo estos factores de riesgo interactúan para calcular su riesgo general y destaca qué factores de riesgo se pueden tratar para reducirlo.
                            <br/>La información y las recomendaciones que aparecen en esta calculadora son adecuadas en la mayoría de los casos, pero no reemplazan el diagnóstico médico. Para obtener información específica relacionada con su condición personal, consulte a su médico. <br/><br/><span className='HeartAgeCalculatorResultsRightSideWhatIfConsequenceTextOption' onClick={() => toggleDescription("More",1)} style={{fontWeight: "800"}}>Leer más...</span></div>
                        </div>
                      </div>
                      <div className='UserWelcomeBlockPageWideSideR'>
                        <div className="UserProfileDiabetesWhiteBoxPart2">
                            <h5 className="HeartAgeCalculatorLeftSideResultPartName">2. Indicadores en Riesgo</h5>
                            <h2 className="HeartAgeCalculatorLeftSideResultTitle">¿Qué indicadores están comprometiendo tu salud?</h2>
                            <div className="HeartAgeCalculatorLeftSideResultParameterBox">
                                { RegSistolic > 0 ?
                                <>
                                <div className="HeartAgeCalculatorLeftSideResultParameterBloodBlock" style={{ backgroundColor: Sistolic < 120 ? "rgba(139, 197, 63, 1)" : Sistolic < 130 ? "rgba(255, 205, 41, 1)" : "rgba(255, 79, 83, 1)", color: Sistolic >= 120 & Sistolic < 130 ? "#330066" : "white" }}>
                                    <img alt="" className="HeartAgeCalculatorLeftResultParameterCardiacIcon" src={Sistolic >= 120 & Sistolic <= 130 ? "https://static.yomecontrolo.cl/public/icons/DarkPurpleCardioHeartTrasparent.png" : "https://static.yomecontrolo.cl/public/icons/WhiteCardioHeartIcon.png"}/>
                                    <div className="HeartAgeCalculatorLeftSideResultParameterIMCBlockInnerFlex">
                                        <div className="HeartAgeCalculatorLeftSideResultParameterIMCBlockInnerBlock">
                                            <div className="HeartAgeCalculatorLeftSideResultParameterIMCBlockInnerBlockText1">Presión arterial</div>
                                            <h4 className="HeartAgeCalculatorLeftSideResultParameterIMCBlockInnerBlockText1">{Sistolic}mmHg</h4>
                                        </div>
                                        <div className="HeartAgeCalculatorLeftSideResultParameterIMCBlockInnerBlock">
                                            <div className="HeartAgeCalculatorLeftSideResultParameterIMCBlockInnerBlockText2">Rango recomendado</div>
                                            <div className="HeartAgeCalculatorLeftSideResultParameterIMCBlockInnerBlockText2">100 a 120 mmHg</div>
                                        </div>
                                    </div>
                                </div>
                                {Risk.heartAge - RegSistolic > 0 & Age >= 40 ?
                                <h4 className="HeartAgeCalculatorLeftSideResultParameterTitle">Si regulas tu presión arterial al 120mmHg ganarías {Risk.heartAge - RegSistolic} años</h4>
                                : null}
                                {Sistolic > 130 ?
                                <>
                                <div className="HeartAgeCalculatorLeftSideResultParameterSubtitle" id="More2">Una presión arterial de {Sistolic} mmHg es extremadamente peligrosa y se considera una crisis hipertensiva. <span className='HeartAgeCalculatorResultsRightSideWhatIfConsequenceTextOption' onClick={() => toggleDescription("Less",2)} style={{fontWeight: "800"}}>Leer más...</span></div>
                                <div className="HeartAgeCalculatorLeftSideResultParameterSubtitle HeartAgeCalculatorResultsRightSideWhatIfConsequenceHidden" id="Less2">Una presión arterial de {Sistolic} mmHg es extremadamente peligrosa y se considera una crisis hipertensiva. Esta es una emergencia médica que requiere atención inmediata porque puede causar daños graves a órganos vitales y provocar complicaciones potencialmente mortales. <span className='HeartAgeCalculatorResultsRightSideWhatIfConsequenceTextOption' onClick={() => toggleDescription("More",2)} style={{fontWeight: "800"}}>Leer menos...</span></div>
                                </>
                                : Sistolic > 120 ?  
                                <div className="HeartAgeCalculatorLeftSideResultParameterSubtitle">Una presión arterial de entre 120 y 130 mmHg se considera alta, pero no peligrosa. Cuida tu presión para mentenerte saludable.</div>
                                :
                                <div className="HeartAgeCalculatorLeftSideResultParameterSubtitle">Tu presión arterial está en un rango saludable.</div>
                                }
                                <div className="HeartAgeCalculatorLeftSideResultParameterHorizontalLine"></div>
                                </>
                                : null}
                                {IMC.length !== 0 ?
                                <>
                                <div className="HeartAgeCalculatorLeftSideResultParameterIMCBlock">
                                    <img alt="" className="HeartAgeCalculatorLeftResultParameterCardiacIcon" src="https://static.yomecontrolo.cl/public/icons/YellowWeightIcon.png"/>
                                    <div className="HeartAgeCalculatorLeftSideResultParameterIMCBlockInnerFlex">
                                        <div className="HeartAgeCalculatorLeftSideResultParameterIMCBlockInnerBlock">
                                            <div className="HeartAgeCalculatorLeftSideResultParameterIMCBlockInnerBlockText1">Peso: {IMC[1]}</div>
                                            <h4 className="HeartAgeCalculatorLeftSideResultParameterIMCBlockInnerBlockText1">{IMC[4]}Kg</h4>
                                        </div>
                                        <div className="HeartAgeCalculatorLeftSideResultParameterIMCBlockInnerBlock">
                                            <div className="HeartAgeCalculatorLeftSideResultParameterIMCBlockInnerBlockText2">Rango recomendado</div>
                                            <div className="HeartAgeCalculatorLeftSideResultParameterIMCBlockInnerBlockText2">{IMC[2]} a {IMC[3]} kg</div>
                                        </div>
                                    </div>
                                </div>
                                </>
                                : null}
                                { RegCholes > 0 & Risk.heartAge - RegCholes > 1 ?
                                <>
                                <div className="HeartAgeCalculatorLeftSideResultParameterHorizontalLine"></div>
                                {Age >= 40 ?
                                <h4 className="HeartAgeCalculatorLeftSideResultParameterTitle">Si regulas tu colesterol total a 154mg/dL ganarías {Risk.heartAge - RegCholes} años</h4>
                                : null}
                                <div className="HeartAgeCalculatorLeftSideResultParameterSubtitle" id="More3">Para mejorar tu peso de manera saludable, realiza ajustes en tu alimentación, controlando porciones y evitando alimentos ultraprocesados. <span className='HeartAgeCalculatorResultsRightSideWhatIfConsequenceTextOption' onClick={() => toggleDescription("Less",3)} style={{fontWeight: "800"}}>Leer más...</span></div>
                                <div className="HeartAgeCalculatorLeftSideResultParameterSubtitle HeartAgeCalculatorResultsRightSideWhatIfConsequenceHidden" id="Less3">Para mejorar tu peso de manera saludable, realiza ajustes en tu alimentación, controlando porciones y evitando alimentos ultraprocesados. Incorpora más frutas, verduras y proteínas saludables. Aumenta tu actividad física con ejercicios aeróbicos y de fuerza. Establece metas realistas, maneja el estrés y asegúrate de dormir lo suficiente. <span className='HeartAgeCalculatorResultsRightSideWhatIfConsequenceTextOption' onClick={() => toggleDescription("More",3)} style={{fontWeight: "800"}}>Leer menos...</span></div>
                                </>
                                : null}
                            </div>
                            <h4 className="HeartAgeCalculatorLeftSideResultParameterLowerText">Si mejoras estos indicadores en riesgo podrás mejorar significativamente tu proyección de salud futura.</h4>
                            <div className='UserWelcomeBlockPageWideFlex'>
                              <div className='GeneralWhiteButtonFlex UserWelcomeBlockPageButton2' onClick={() => {document.body.scrollTop = 0; document.documentElement.scrollTop = 0; Navigate("/perfil-de-usuario/calculadora-de-salud");}}>Terminar</div>
                              <div className='GeneralPurpleButtonFlex UserWelcomeBlockPageButton' onClick={() => {document.body.scrollTop = 0; document.documentElement.scrollTop = 0; Navigate("/plan-de-intervencion");}}>Ir a Recomendaciones</div>
                            </div>
                        </div>
                      </div>
                    </div>
                    
                  </>
                  : null}
                </div>
            </div>
        </div>
    );
};

export default HeartAgeCalculator;